@import "../../sass/variables/variables";

:host {
  display: block;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 10px 10px 10px 0;

  > li {
    padding: 0 25px;
  }
}

::slotted(ul) {
  list-style-type: none;
}

.ux-dropdown__item--hidden {
  display: none;
}

.ux-input {
  background-color: $color-white;
  border: 1px solid $color-gray-borders;
  display: inline-block;
  font-family: var(--ux-font);
  font-size: var(--ux-input-font-size);
  font-weight: var(--ux-input-font-weight);
  height: var(--ux-input-height);
  padding: var(--ux-input-padding);
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: $color-black;
    outline: 0;
  }

  .ux-form-group--error &,
  &--error {
    border-color: var(--ux-input-error-border-color);
    color: var(--ux-input-error-hint-color);

    &:focus {
      border-color: var(--ux-input-error-border-color);
    }
  }

  .ux-form-group--disabled &,
  &--disabled {
    opacity: 0.4;
  }
}


.ux-list__filter-input {
  border-left: 0;
  border-right: 0;
  margin-bottom: 10px;
  padding-left: $dropdown-padding-horizontal;
  padding-right: $dropdown-padding-horizontal;
}
